import {useEffect} from 'react';
import EditorJS from "@editorjs/editorjs";
import Underline from "@editorjs/underline";
import List from '@editorjs/list';
import YoutubeEmbed from 'editorjs-youtube-embed'
import Header from "@editorjs/header";
import Embed from '@editorjs/embed';
import {CustomHyperlink} from "./plugins/CustomHyperlink";

function sanitizeOutput (data) {
  return {
    ...data,
    blocks: data.blocks.map((block) => {
      if (block.type !== 'paragraph' && block.type !== 'header') {
        return block;
      }

      return {
        ...block,
        data: {
          ...block.data,
          text: block.data.text
            .replace(/&nbsp;/g, ' ')
            .trim(),
        },
      };
    }),
  }
}

export default function AuthorEditor ({user,onChange}) {
  useEffect(() => {
      let data;
      try {
        data = JSON.parse(user.profile.bio);
      } catch {
        data = {
          blocks: [
            {
              type: 'paragraph',
              data: {
                text: user.profile.bio,
              },
            },
          ],
        };
      }

      let editorTools = {
        link: {
          class: CustomHyperlink,
          config: {
            shortcut: 'CMD+L',
            target: '_blank',
            rel: 'nofollow',
            availableTargets: ['_blank'],
            availableRels: ['nofollow','follow'],
            validate: false,
          }
        },
        embed: {
          class: Embed,
          config: {
            services: {
              twitter: true,
              twitterX: {
                regex: /^https?:\/\/x\.com\/(?:#!\/)?(\w+)\/status(?:es)?\/(\d+?.*)?$/,
                embedUrl: 'https://twitframe.com/show?url=https://twitter.com/<%= remote_id %>',
                html: '<iframe width="600" height="600" style="margin: 0 auto;" frameborder="0" scrolling="no" allowtransparency="true"></iframe>',
                height: 300,
                width: 600,
                id: ids => ids.join('/status/'),
              },
              tiktok: {
                regex: /^https?:\/\/(?:www\.)?tiktok\.com\/@\w+\/video\/(\d+)(?:\?.*)?$/,
                embedUrl: 'https://www.tiktok.com/embed/v2/<%= remote_id %>',
                html: '<iframe width="600" height="800" style="margin: 0 auto;" frameborder="0" scrolling="no" allowtransparency="true"></iframe>',
                height: 800,
                width: 600,
                id: ids => ids.join('/embed/'),
              },
              // facebook: true,
              instagram: true,
            },
          },
        },
        youtubeEmbed: YoutubeEmbed,
        list: {
          class: List,
          inlineToolbar: true,
          config: {
            defaultStyle: 'unordered'
          }
        },

        underline: Underline,
        header: Header
      }

      const editor = new EditorJS({
        holder: 'editorjs',
        placeholder: 'Biografia...',
        tools: editorTools,
        data: data,
        onChange: () => {
          editor.save().then((outputData) => {
            const sanitizedOutput = sanitizeOutput(outputData);
            console.log('Saving...', sanitizedOutput);
            onChange(sanitizedOutput);
          }).catch((error) => {
            console.error('Saving failed: ', error);
          });
        }
      });

      return () => editor.destroy();
    }
    ,
    [user.id]
  )
  ;

  return (
    <div id="editorjs" className={'authorEditor'}></div>
  );
}
